<template>
  <!-- UGC 规则弹窗 -->
  <transition name="fade" mode="out-in">
    <div class="v3-popup task-rule-popup" v-show="visible">
      <div class="v3-popup-mask" @click="handleClose"></div>
      <div class="v3-popup-content large">
        <div class="v3-popup-content-close" @click="handleClose"></div>
        <div class="v3-popup-content-title">{{ langData.taskRulePopupTitle }}</div>
        <div class="v3-popup-content-content task-rule-content">{{ langData.ugcRuleRules }}</div>
        <div class="v3-popup-content-footer">
          <div class="confirm-btn btns" @click="handleClose">{{ langData.confirmBtn }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import LanguageHook from '@hooks/language';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'close']);

const { langData } = LanguageHook();

const handleClose = () => {
  emit('update:visible', false);
  emit('close');
};
</script>
